import { AssetTemplateFilterControl } from './AssetTemplateFilterControl';
import { useQueryCampaignTemplates } from '~/modules/campaign-template';
import { useQueryCampaignUrls } from '~/modules/campaign-url-redirect';
import { useAssetTemplateContext } from '~/modules/asset-template';
import { useQueryCampaignGroups } from '~/modules/campaign-group';
import { useQueryCampaignPrices } from '~/modules/campaign-price';
import { Box, InlineStack, Button } from '@shopify/polaris';
import { useAssetTemplatePickerContext } from '../contexts';
import { RefreshIcon } from '@shopify/polaris-icons';
import { useAsyncWithErrorToast } from '~/hooks';
import { GTooltip } from '~/presentation/ui';

export const AssetTemplateFilterWrapper = () => {
  const { isLoadingAsset } = useAssetTemplateContext();
  const { handleRefetchAsset } = useAssetTemplateContext();
  const { handleRefetch: handleRefetchCampaignTemplates, isFetching: isFetchingCampaignTemplates } =
    useQueryCampaignTemplates();
  const { refetch: handleRefetchCampaignGroups, isFetching: isFetchingCampaignGroups } =
    useQueryCampaignGroups();
  // Price experiments lock templates through the product they run on and URL experiments through the
  // page they send traffic to, so both gate the listing too.
  const { handleRefetch: handleRefetchCampaignPrices, isFetching: isFetchingCampaignPrices } =
    useQueryCampaignPrices();
  const { handleRefetch: handleRefetchCampaignUrls, isFetching: isFetchingCampaignUrls } =
    useQueryCampaignUrls();
  // Which template either test holds lives on the record behind its page, not on the campaign — so
  // those have to be pulled again too, otherwise the listing keeps reading a suffix from before the
  // pages were unassigned.
  const {
    handleRefetchPriceProducts,
    isFetchingPriceProducts,
    handleRefetchUrlDestinations,
    isFetchingUrlDestinations,
  } = useAssetTemplatePickerContext();
  const withErrorToast = useAsyncWithErrorToast();

  const isFetching =
    isLoadingAsset ||
    isFetchingCampaignTemplates ||
    isFetchingCampaignGroups ||
    isFetchingCampaignPrices ||
    isFetchingCampaignUrls ||
    isFetchingPriceProducts ||
    isFetchingUrlDestinations;

  const handleRefresh = () =>
    withErrorToast(
      async () => {
        await Promise.all([
          handleRefetchAsset(),
          handleRefetchCampaignTemplates(),
          handleRefetchCampaignGroups(),
          handleRefetchCampaignPrices(),
          handleRefetchPriceProducts(),
          handleRefetchCampaignUrls(),
          handleRefetchUrlDestinations(),
        ]);
      },
      { source: 'AssetTemplateFilterWrapper.handleRefresh', tags: { experiment: 'Experiment' } },
    );

  return (
    <AssetTemplateFilterControl>
      <Box minHeight="100%">
        <InlineStack gap="200">
          <GTooltip content={`Refresh to update`}>
            <Button icon={RefreshIcon} disabled={isFetching} onClick={handleRefresh} />
          </GTooltip>
        </InlineStack>
      </Box>
    </AssetTemplateFilterControl>
  );
};
